module.exports = __webpack_public_path__ + "img/16.e92fc22b.jpg";